import { useContext } from "react";
import AuthContext from "../contexts/AuthProvider";
var useAuth = function () {
    return useContext(AuthContext);
};
export default useAuth;
